<hs-card [hsLayer]="'one'">
  <hs-card-body>
    <!-- Header row -->
    <div class="flex flex-row mb-4">
      <hs-icon class="mr-4" [innerHTML]="shoppingCartIcon"></hs-icon>
      <div class="header">{{ shoppingCartLabel }}</div>
      <span class="flex-1"></span>
      @if (isEditable()) {
        <div class="flex gap-2">
          @if (cartItems() && cartItems().length > 0) {
            <button
              hsIconButton
              (click)="btnDragAndDropClicked()"
              [hsTooltip]="tooltipDragDrop"
            >
              <hs-icon [innerHTML]="iconEdit"></hs-icon>
            </button>
          }
          <button hsIconButton [hsMenuTrigger]="menu" [hsTooltip]="tooltipNew">
            <hs-icon [innerHTML]="iconNew"></hs-icon>
          </button>

          <ng-template #menu>
            <hs-menu>
              <hs-menu-item (click)="onNewArticleClicked()">{{
                newItemLabel
              }}</hs-menu-item>
              <hs-menu-item (click)="onNewTextArticleClicked()">{{
                newTextItemLabel
              }}</hs-menu-item>
              <hs-menu-item (click)="onNewSurchargeDiscountClicked()">{{
                newSurchargeDiscountLabel
              }}</hs-menu-item>
              <hs-menu-item (click)="onArticleCatalogClicked()">{{
                articleCatalogLabel
              }}</hs-menu-item>
            </hs-menu>
          </ng-template>
        </div>
      }
    </div>

    <!-- Cart table -->
    @if (cartItems() && cartItems().length > 0) {
      <div class="overflow-x-auto">
        <table class="w-full border-collapse text-sm">
          <thead>
            <tr class="border-b border-current/20">
              @if (dragAndDrop()) {
                <th class="w-8 pb-2"></th>
              }
              <th class="pb-2 pr-2 text-left font-medium">
                {{ articleNumberLabel }}
              </th>
              <th class="pb-2 pr-2 text-left font-medium">
                {{ manufacturerLabel }}
              </th>
              <th class="pb-2 pr-2 text-left font-medium w-20">
                {{ quantityLabel }}
              </th>
              <th class="pb-2 pr-2 text-left font-medium w-16">
                {{ unitLabel }}
              </th>
              <th class="pb-2 pr-2 text-left font-medium">
                {{ shortTextLabel }}
              </th>
              @if (showListPrice()) {
                <th class="pb-2 pr-2 text-left font-medium">
                  {{ netEpLabel }}
                </th>
                <th class="pb-2 pr-2 text-left font-medium w-24">
                  {{ vatShortLabel }}
                </th>
                <th class="pb-2 pr-2 text-left font-medium">
                  {{ netGpLabel }}
                </th>
              }
              @if (canEdit()) {
                <th class="pb-2 w-20"></th>
              }
            </tr>
          </thead>

          <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            @for (item of cartItems(); track item.uId; let idx = $index) {

              <!-- Divider before first cart-level discount/surcharge -->
              @if (idx === firstIndexOfManipulationItem()) {
                <tr>
                  <td [attr.colspan]="tableColspan()" class="py-1 px-0">
                    <hs-divider></hs-divider>
                  </td>
                </tr>
              }

              <!-- ── Discount / Surcharge row ─────────────────────────────── -->
              @if (isManipulationPosition(item)) {
                <tr
                  cdkDrag
                  [cdkDragDisabled]="!canDragAndDrop(item)"
                  class="border-b border-current/10"
                >
                  @if (dragAndDrop()) {
                    <td class="py-2 w-8 align-middle">
                      @if (canDragAndDrop(item)) {
                        <hs-icon
                          cdkDragHandle
                          [width]="20"
                          [height]="20"
                          [innerHTML]="iconDragDrop"
                          class="cursor-grab"
                        ></hs-icon>
                      }
                    </td>
                  }
                  <td
                    [attr.colspan]="contentColspan()"
                    class="py-2 align-middle italic"
                    [hsTooltip]="showFullName(item)"
                  >
                    {{ getItemHeader(item) }}
                  </td>
                  @if (canEdit()) {
                    <td class="py-2 align-middle text-right">
                      <div class="flex gap-1 justify-end">
                        @if (showEditButton() && isEditable()) {
                          <button
                            hsIconButton
                            [hsTooltip]="tooltipEdit"
                            (click)="btnEditClicked(item)"
                            hsButtonColor="primary"
                          >
                            <hs-icon
                              [width]="20"
                              [height]="20"
                              [innerHTML]="iconEdit"
                            ></hs-icon>
                          </button>
                        }
                        @if (showDeleteButton() && isEditable()) {
                          <button
                            hsIconButton
                            [hsTooltip]="deleteItemLabel"
                            (click)="btnDeleteClicked(item)"
                            hsButtonColor="danger"
                          >
                            <hs-icon
                              [width]="20"
                              [height]="20"
                              [innerHTML]="iconDelete"
                            ></hs-icon>
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>

              <!-- ── Text position row ──────────────────────────────────────── -->
              } @else if (isTextItem(item)) {
                <tr
                  cdkDrag
                  [cdkDragDisabled]="!dragAndDrop()"
                  class="border-b border-current/10"
                >
                  @if (dragAndDrop()) {
                    <td class="py-1 w-8 align-middle">
                      <hs-icon
                        cdkDragHandle
                        [width]="20"
                        [height]="20"
                        [innerHTML]="iconDragDrop"
                        class="cursor-grab"
                      ></hs-icon>
                    </td>
                  }
                  <td [attr.colspan]="contentColspan()" class="py-1 align-middle">
                    <input
                      hsInput
                      class="w-full"
                      [placeholder]="shortTextLabel"
                      [value]="item.infoDesc ?? ''"
                      [disabled]="!isEditable()"
                      (blur)="onInfoDescBlur(item, $event)"
                    />
                  </td>
                  @if (canEdit()) {
                    <td class="py-1 align-middle text-right">
                      @if (showDeleteButton() && isEditable()) {
                        <button
                          hsIconButton
                          [hsTooltip]="deleteItemLabel"
                          (click)="btnDeleteClicked(item)"
                          hsButtonColor="danger"
                        >
                          <hs-icon
                            [width]="20"
                            [height]="20"
                            [innerHTML]="iconDelete"
                          ></hs-icon>
                        </button>
                      }
                    </td>
                  }
                </tr>

              <!-- ── Regular article row ────────────────────────────────────── -->
              } @else {
                <tr
                  cdkDrag
                  [cdkDragDisabled]="!dragAndDrop()"
                  class="border-b border-current/10"
                >
                  @if (dragAndDrop()) {
                    <td class="py-1 w-8 align-middle">
                      <hs-icon
                        cdkDragHandle
                        [width]="20"
                        [height]="20"
                        [innerHTML]="iconDragDrop"
                        class="cursor-grab"
                      ></hs-icon>
                    </td>
                  }
                   <!-- Artikelnummer -->
                  <td class="py-1 pr-2 align-middle">
                    <input
                      hsInput
                      class="w-full"
                      [value]="item.articleNumber ?? ''"
                      [placeholder]="articleNumberLabel"
                      [disabled]="!isEditable()"
                      (blur)="onArticleNumberBlur(item, $event)"
                    />
                  </td>
                  <!-- Hersteller -->
                  <td class="py-1 pr-2 align-middle">
                    <input
                      hsInput
                      class="w-full"
                      [value]="item.manufacturerLabel ?? ''"
                      [placeholder]="manufacturerLabel"
                      [disabled]="!isEditable()"
                      (blur)="onManufacturerBlur(item, $event)"
                    />
                  </td>
                  <!-- Menge -->
                  <td class="py-1 pr-2 align-middle w-20">
                    <input
                      hsInput
                      class="w-full"
                      type="number"
                      [value]="item.amount"
                      [placeholder]="quantityLabel"
                      [disabled]="!isEditable()"
                      (blur)="onAmountBlur(item, $event)"
                    />
                  </td>
                  <!-- Einheit -->
                  <td class="py-1 pr-2 align-middle w-16">
                    <input
                      hsInput
                      class="w-full"
                      [value]="item.unit ?? ''"
                      [placeholder]="unitLabel"
                      [disabled]="!isEditable()"
                      (blur)="onUnitBlur(item, $event)"
                    />
                  </td>
                  <!-- Kurztext -->
                  <td class="py-1 pr-2 align-middle">
                    <input
                      hsInput
                      class="w-full"
                      [value]="item.infoDesc ?? ''"
                      [placeholder]="shortTextLabel"
                      [disabled]="!isEditable()"
                      (blur)="onInfoDescBlur(item, $event)"
                    />
                  </td>
                  @if (showListPrice()) {
                    <!-- Netto Einzelpreis -->
                    <td class="py-1 pr-2 align-middle">
                      <input
                        hsInput
                        class="w-full"
                        type="number"
                        [value]="item.priceTotal?.netTotal ?? 0"
                        [disabled]="!isEditable()"
                        (blur)="onNetPriceBlur(item, $event)"
                      />
                    </td>
                    <!-- MwSt % -->
                    <td class="py-1 pr-2 align-middle w-24">
                      <hs-select
                        [options]="vatOptions"
                        [selectedValue]="getVatString(item)"
                        [disabled]="!isEditable()"
                        (selectionChanged)="onVatChanged(item, $event)"
                      ></hs-select>
                    </td>
                    <!-- Gesamtpreis (berechnet) -->
                    <td class="py-1 px-2 align-middle whitespace-nowrap">
                      {{ getLineTotal(item) | number: '1.2-2' }}€
                    </td>
                  }
                  @if (canEdit()) {
                    <td class="py-1 align-middle text-right w-20">
                      <div class="flex gap-1 justify-end">
                        @if (showEditButton() && isEditable()) {
                          <button
                            hsIconButton
                            [hsTooltip]="tooltipEdit"
                            (click)="btnEditClicked(item)"
                            hsButtonColor="primary"
                          >
                            <hs-icon
                              [width]="20"
                              [height]="20"
                              [innerHTML]="iconEdit"
                            ></hs-icon>
                          </button>
                        }
                        @if (showDeleteButton() && isEditable()) {
                          <button
                            hsIconButton
                            [hsTooltip]="deleteItemLabel"
                            (click)="btnDeleteClicked(item)"
                            hsButtonColor="danger"
                          >
                            <hs-icon
                              [width]="20"
                              [height]="20"
                              [innerHTML]="iconDelete"
                            ></hs-icon>
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }

    <!-- Sum block -->
    @if (showListPrice() && cartItems() && cartItems().length > 0) {
      <div class="flex flex-col gap-2.5 mt-4">
        <!-- Divider -->
        <div class="flex flex-row">
          <div class="w-1/2"></div>
          <div class="w-1/2">
            <hs-divider></hs-divider>
          </div>
        </div>

        <!-- Netto-Summe / Bezugswert -->
        <div class="flex flex-row">
          <div class="w-1/2"></div>
          <div class="flex flex-row w-1/2">
            <div class="w-1/2">
              @if (discount() > 0 || surcharge() > 0) {
                {{ referenceValueLabel }}
              } @else {
                {{ priceLabel }}
              }
            </div>
            <div class="flex w-1/2 justify-end">
              {{ sumNettoPrice() | number: '1.2-2' }}€
            </div>
          </div>
        </div>

        @if (discount() > 0 || surcharge() > 0) {
          <div class="flex flex-row">
            <div class="w-1/2"></div>
            <div class="w-1/2">
              <hs-divider></hs-divider>
            </div>
          </div>

          @if (discount() > 0) {
            <div class="flex flex-row">
              <div class="w-1/2"></div>
              <div class="w-1/2 flex flex-row">
                <div class="w-1/2">{{ discountLabel }}</div>
                <div class="flex w-1/2 justify-end">
                  - {{ discount() | number: '1.2-2' }}€
                </div>
              </div>
            </div>
          }

          @if (surcharge() > 0) {
            <div class="flex flex-row">
              <div class="w-1/2"></div>
              <div class="w-1/2 flex flex-row">
                <div class="w-1/2">{{ surchargeLabel }}</div>
                <div class="flex w-1/2 justify-end">
                  + {{ surcharge() | number: '1.2-2' }}€
                </div>
              </div>
            </div>
          }

          <div class="flex flex-row">
            <div class="w-1/2"></div>
            <div class="w-1/2">
              <hs-divider></hs-divider>
            </div>
          </div>
        }

        <!-- MwSt per Gruppe -->
        @for (group of vatGroups(); track group.vat) {
          <div class="flex flex-row">
            <div class="w-1/2"></div>
            <div class="w-1/2 flex flex-row">
              <div class="w-1/2">
                {{ mwstText.replace('$$', group.vat.toString()) }}
              </div>
              <div class="flex w-1/2 justify-end">
                {{ group.vatAmount | number: '1.2-2' }}€
              </div>
            </div>
          </div>
        }

        <!-- Doppellinie + Gesamtsumme -->
        <div class="flex flex-row">
          <div class="w-1/2"></div>
          <div class="flex flex-col w-1/2 gap-2">
            <hs-divider></hs-divider>
            <hs-divider></hs-divider>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="w-1/2"></div>
          <div class="w-1/2 flex flex-row">
            <div class="w-1/2">
              <b>{{ sumLabel }}</b>
            </div>
            <div class="flex w-1/2 justify-end">
              <b>{{ totalPrice() | number: '1.2-2' }}€</b>
            </div>
          </div>
        </div>
      </div>
    }
  </hs-card-body>
</hs-card>
